import darmosharkM6UltraImage from './darmoshark-m6-ultra.png';
import darmosharkM6UltraVectorImage from './darmoshark-m6-ultra.svg';
import darmosharkM9Image from './darmoshark-m9.svg';
import darmosharkM9PhotoImage from './darmoshark-m9.png';
import waniHs1Image from './wani-hs1.jpg';
import waniHs1VectorImage from './wani-hs1.svg';

export const MOUSE_BUTTON_LABELS = Object.freeze({
  left: '左键',
  right: '右键',
  middle: '中键',
  scrollUp: '滚轮上',
  scrollDown: '滚轮下',
  button4: '侧键4',
  button5: '侧键5',
});

const m9ButtonPaths = Object.freeze({
  left:
    'M84.14 3.21 C61 6 35 17 18.72 29.6 C13 33 9 37 7.96 40.22 C7.95 53.8 8.5 67.4 9.59 80.9 C10.2 94.6 11.1 108.3 12.22 121.94 C13.05 134.1 14.1 146.3 15.35 158.32 C15.9 164.8 20.1 169.2 26.05 169.78 H95.9 V107.48 C89.3 107.1 84.14 104.2 84.14 99.9 Z',
  right:
    'M109.08 3.21 C132.22 6 158.22 17 174.5 29.6 C180.22 33 184.22 37 185.26 40.22 C185.27 53.8 184.72 67.4 183.63 80.9 C183.02 94.6 182.12 108.3 181 121.94 C180.17 134.1 179.12 146.3 177.87 158.32 C177.32 164.8 173.12 169.2 167.17 169.78 H97.32 V107.48 C103.92 107.1 109.08 104.2 109.08 99.9 Z',
  scrollUp: 'M88.03 54.8 H105.19 V72.9 H88.03 Z',
  middle: 'M88.03 72.9 H105.19 V90.9 H88.03 Z',
  scrollDown: 'M88.03 90.9 H105.19 V106.7 H88.03 Z',
  button4:
    'M6.4 121.2 C10.5 121.5 13.5 125 14 130 L17.2 162 C17.5 168 13.5 176 8.9 180 L5.7 172.9 Z',
  button5:
    'M9 180 C13 180 16 185 16.5 191 L17.3 231.9 C16.8 234.5 14 236 11 236 L7.7 230.4 Z',
});

const m9LabelPositions = Object.freeze({
  left: { point: { x: 60, y: 70 }, label: { x: -148, y: 36 }, direction: 'left' },
  right: { point: { x: 140, y: 70 }, label: { x: 236, y: 36 }, direction: 'right' },
  middle: { point: { x: 100, y: 68 }, label: { x: 236, y: 118 }, direction: 'right' },
  scrollUp: { point: { x: 100, y: 53 }, label: { x: 236, y: 200 }, direction: 'right' },
  scrollDown: { point: { x: 100, y: 82 }, label: { x: 236, y: 282 }, direction: 'right' },
  button4: { point: { x: 30, y: 125 }, label: { x: -148, y: 150 }, direction: 'left' },
  button5: { point: { x: 31, y: 172 }, label: { x: -148, y: 264 }, direction: 'left' },
});

// M6 Ultra 的原始 SVG 是 CAD 线稿，没有语义化的按键节点。
// 点击区域单独维护，避免修改设计源文件，也避免与 M9 的坐标耦合。
const m6UltraButtonPaths = Object.freeze({
  left:
    'M77.5 2.9 C56.2 5.4 32.2 15.2 17.2 26.4 C12 29.4 8.3 33 7.3 35.9 C7.3 48 7.8 60.1 8.8 72.2 C9.4 84.4 10.2 96.6 11.3 108.8 C12 119.6 13 130.5 14.1 141.2 C14.6 147 18.5 151 24 151.4 H88.3 V95.9 C82.2 95.6 77.5 92.9 77.5 89.1 Z',
  right:
    'M100.5 2.9 C121.8 5.4 145.8 15.2 160.8 26.4 C166 29.4 169.7 33 170.7 35.9 C170.7 48 170.2 60.1 169.2 72.2 C168.6 84.4 167.8 96.6 166.7 108.8 C166 119.6 165 130.5 163.9 141.2 C163.4 147 159.5 151 154 151.4 H89.7 V95.9 C95.8 95.6 100.5 92.9 100.5 89.1 Z',
  // PNG 中滚轮的实际范围约为 x=531..670、y=257..578。
  // 这里按滚轮实体均分为上滚、中键、下滚三段，坐标会再经过
  // buttonTransform 映射到 1200 × 2000 的 PNG 画布。
  scrollUp: 'M75.8 36.5 H102.2 V56.8 H75.8 Z',
  middle: 'M75.8 56.8 H102.2 V77.1 H75.8 Z',
  scrollDown: 'M75.8 77.1 H102.2 V97.5 H75.8 Z',
  button4:
    'M5.9 108.1 C9.7 108.4 12.4 111.5 12.9 116 L15.8 144.5 C16.1 149.8 12.4 157 8.2 160.5 L5.2 154.2 Z',
  button5:
    'M8.3 160.5 C12 160.5 14.7 165 15.2 170.4 L15.9 206.8 C15.5 209.1 12.9 210.5 10.1 210.5 L7.1 205.5 Z',
});

const m6UltraLabelPositions = Object.freeze({
  left: { point: { x: 58, y: 66 }, label: { x: -148, y: 36 }, direction: 'left' },
  right: { point: { x: 142, y: 66 }, label: { x: 236, y: 36 }, direction: 'right' },
  middle: { point: { x: 100, y: 67 }, label: { x: 236, y: 118 }, direction: 'right' },
  scrollUp: { point: { x: 100, y: 50 }, label: { x: 236, y: 200 }, direction: 'right' },
  scrollDown: { point: { x: 100, y: 84 }, label: { x: 236, y: 282 }, direction: 'right' },
  button4: { point: { x: 28, y: 116 }, label: { x: -148, y: 150 }, direction: 'left' },
  button5: { point: { x: 29, y: 160 }, label: { x: -148, y: 264 }, direction: 'left' },
});

// wani-hs1 的 SVG 画在 1407×1407 产品照上，只有左右键和两个侧键。
// 点击区域单独维护，避免改设计源文件；滚轮按照片实体均分成三段。
const waniHs1ButtonPaths = Object.freeze({
  left:
    'M480 569C468.8 531.4 462.667 364 461 285C470.5 259.167 517 202.5 663.5 183C663.333 272.5 663.1 453.3 663.5 460.5C663.9 467.7 688.333 470.5 700.5 471V587.5H498.5C491.3 589.9 483.167 576.167 480 569Z',
  right:
    'M928.5 569C939.7 531.4 945.833 364 947.5 285C938 259.167 891.5 202.5 745 183C745.167 272.5 745.4 453.3 745 460.5C744.6 467.7 720.167 470.5 708 471V587.5H910C917.2 589.9 925.333 576.167 928.5 569Z',
  // 照片里滚轮约 x=670..738、y=290..420。
  scrollUp: 'M670 290 H738 V333 H670 Z',
  middle: 'M670 333 H738 V376 H670 Z',
  scrollDown: 'M670 376 H738 V420 H670 Z',
  button4:
    'M440.5 628.5L432.5 502H446C449.833 540.833 458.3 621.4 457.5 625C456.7 628.6 445.5 628.833 440.5 628.5Z',
  button5:
    'M444 780.5L442 652L461.5 653L466.5 769C465.3 777 450.333 780 444 780.5Z',
});

// 标签坐标落在 200×320 的预览盒里，对应 viewBox 裁切后的热区位置。
const waniHs1LabelPositions = Object.freeze({
  left: { point: { x: 56, y: 61 }, label: { x: -148, y: 36 }, direction: 'left' },
  right: { point: { x: 144, y: 61 }, label: { x: 236, y: 36 }, direction: 'right' },
  middle: { point: { x: 100, y: 59 }, label: { x: 236, y: 118 }, direction: 'right' },
  scrollUp: { point: { x: 100, y: 46 }, label: { x: 236, y: 200 }, direction: 'right' },
  scrollDown: { point: { x: 100, y: 73 }, label: { x: 236, y: 282 }, direction: 'right' },
  button4: { point: { x: 21, y: 123 }, label: { x: -148, y: 150 }, direction: 'left' },
  button5: { point: { x: 24, y: 169 }, label: { x: -148, y: 264 }, direction: 'left' },
});

const MOUSE_VISUALS = Object.freeze({
  'darmoshark-m9': Object.freeze({
    image: darmosharkM9Image,
    photoImage: darmosharkM9PhotoImage,
    viewBox: '0 0 193.22 386.49',
    buttonPaths: m9ButtonPaths,
    labelPositions: m9LabelPositions,
  }),
  'darmoshark-m6-ultra': Object.freeze({
    image: darmosharkM6UltraImage,
    vectorImage: darmosharkM6UltraVectorImage,
    viewBox: '0 0 1200 2000',
    buttonTransform: 'translate(131 65) scale(5.2753 5.2638)',
    buttonPaths: m6UltraButtonPaths,
    labelPositions: m6UltraLabelPositions,
  }),
  'wani-g1': Object.freeze({
    image: waniHs1Image,
    vectorImage: waniHs1VectorImage,
    imageCanvas: Object.freeze({ width: 1407, height: 1407 }),
    // 产品照四周留白很大；预览按鼠标实体裁切，热区与照片共用这个 viewBox。
    viewBox: '420 160 570 1050',
    buttonPaths: waniHs1ButtonPaths,
    labelPositions: waniHs1LabelPositions,
  }),
});

export function getMouseVisual(modelId) {
  return MOUSE_VISUALS[modelId] || null;
}

export function listMouseVisuals() {
  return Object.entries(MOUSE_VISUALS).map(([modelId, visual]) => ({
    modelId,
    ...visual,
  }));
}

export default MOUSE_VISUALS;
